import { render, staticRenderFns } from "./AdminLocationListMobile.vue?vue&type=template&id=cc6555ec&scoped=true&"
import script from "./AdminLocationListMobile.vue?vue&type=script&lang=ts&"
export * from "./AdminLocationListMobile.vue?vue&type=script&lang=ts&"
import style0 from "./AdminLocationListMobile.vue?vue&type=style&index=0&id=cc6555ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc6555ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDataTable,VTextField})
